import { faker } from '@faker-js/faker/locale/en'

import {
  Article,
  GetPosts,
  GetCategories,
  GetPost,
  GetAllArticles,
  GetPostsSlugsByProperty,
} from './types'
import { freeze } from '@/utils/freeze'

const categories = [
  'Aplicativo',
  'Desenvolvimento',
  'Carreira',
  'Gerenciamento de Projetos',
  'Produto',
  'Sem Categoria',
  'Negócios',
  'teste',
  'testando',
  'novo teste',
  'teste 2',
  'teste 3',
  'teste 4',
  'novo teste 2',
]

const generatePosts = (): Article[] =>
  Array.from({ length: Number(faker.random.numeric(2)) }, (_, index) => ({
    id: `${index + 1}`,
    src: faker.image.abstract(),
    alt: faker.random.words(3),
    fileName: faker.system.fileName(),
    title: faker.name.jobTitle(),
    content: faker.lorem.paragraph(5),
    excerpt: faker.lorem.paragraphs(5),
    about: faker.lorem.paragraph(2),
    amountVisitors: Number(faker.random.numeric(100)),
    seo: {
      metaDescription: faker.lorem.paragraph(2),
      metaTitle: faker.name.jobTitle(),
    },
    author: {
      title: 'Autor do conteúdo',
      name: faker.name.fullName(),
      role: faker.name.jobTitle(),
      avatar: faker.image.avatar(),
    },
    tags: faker.helpers.arrayElements(categories, 2),
    filterBy: faker.helpers.arrayElement(['new', 'popular']),
    slug: `teste ${faker.random.alpha()}`,
    publishedAt: faker.date.past().toISOString(),
  }))

export const getPost: GetPost = async () => {
  await freeze()

  const articles = generatePosts()

  return {
    article: faker.helpers.arrayElement(articles),
    recommendedArticlesTitle: 'Leia também: ',
    recommendedArticles: [],
  }
}

export const getPosts: GetPosts = async () => {
  await freeze()

  const articles = generatePosts()

  return {
    articleHighlight: faker.helpers.arrayElement(articles),
    articles,
    seo: {
      metaDescription: faker.lorem.paragraph(2),
      metaTitle: faker.name.jobTitle(),
      canonicalUrl: faker.internet.url(),
      keywords: faker.random.words(5),
      metaImage: {
        alternativeText: faker.random.words(3),
        height: Number(faker.random.numeric(100)),
        name: faker.random.words(3),
        url: faker.image.abstract(),
        width: Number(faker.random.numeric(100)),
      },
      metaRobots: faker.helpers.arrayElement(['index', 'follow']),
      metaSocial: [],
      metaViewport: '',
      structuredData: {},
    },
    text: {
      title: 'Blog nata.house',
      tagsTitle: 'Categorias',
      notFoundMessage: 'Não encontrado',
      filter: {
        filterBy: 'Filtrar artigos por:',
        placeholderSearch: 'Pesquisar',
        newLabel: 'Novo',
        popularLabel: 'Popular',
      },
    },
  }
}

export const getCategories: GetCategories = async () => {
  await freeze()

  return categories
}

export const getAllArticles: GetAllArticles = async () => {
  await freeze()

  return [
    {
      recommendedArticlesTitle: 'Leia também: ',
      recommendedArticles: [],
      article: {
        seo: {
          metaDescription: faker.lorem.paragraph(2),
          metaTitle: faker.name.jobTitle(),
        },
        id: '3',
        fileName: faker.system.fileName(),
        src: 'https://hotownwh.sirv.com/nh-site/services%202.jpg',
        alt: '5W2H',
        title: 'O que é 5W2H?',
        excerpt: 'loremp ipsum dolor sit amet',
        content:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
        tags: [
          'Aplicativos',
          'Carreiras',
          'Desenvolvimento',
          'Usabilidade',
          'Gerenciamento de Projetos',
        ],
        about: faker.lorem.paragraph(2),
        author: {
          title: 'Autor do conteúdo',
          name: faker.name.fullName(),
          role: faker.name.jobTitle(),
          avatar: faker.image.avatar(),
        },
        amountVisitors: Number(faker.random.numeric(100)),
        filterBy: faker.helpers.arrayElement(['new', 'popular']),
        slug: `teste ${faker.random.alpha()}`,
        publishedAt: faker.date.past().toISOString(),
      },
    },
    {
      recommendedArticlesTitle: 'Leia também: ',
      recommendedArticles: [],
      article: {
        id: '4',
        seo: {
          metaDescription: faker.lorem.paragraph(2),
          metaTitle: faker.name.jobTitle(),
        },
        fileName: faker.system.fileName(),
        src: 'https://hotownwh.sirv.com/nh-site/services%202.jpg',
        alt: '5W2H',
        title: 'O que é 5W2H?',
        excerpt: 'loremp ipsum dolor sit amet',
        content:
          "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.",
        tags: [
          'Aplicativos',
          'Carreiras',
          'Desenvolvimento',
          'Usabilidade',
          'Gerenciamento de Projetos',
        ],
        about: faker.lorem.paragraph(2),
        author: {
          title: 'Autor do conteúdo',
          name: faker.name.fullName(),
          role: faker.name.jobTitle(),
          avatar: faker.image.avatar(),
        },
        amountVisitors: Number(faker.random.numeric(100)),
        filterBy: faker.helpers.arrayElement(['new', 'popular']),
        slug: `teste ${faker.random.alpha()}`,
        publishedAt: faker.date.past().toISOString(),
      },
    },
  ]
}

export const getPostsSlugsByProperty: GetPostsSlugsByProperty = async () => {
  await freeze()

  return []
}
